
export const API_URL = "https://mntr.vonv.dev"